import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, HStack, Image, Text } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import stripesGreen3 from '../../../assets/images/post-wrap/stripes-green-3.png';
import { DistributionMethod, Reward } from '../../../schemas/rewards';

export interface RewardsHighlightsCardProps {
	reward: Reward;
	onClick: () => void;
}

export const RewardsHighlightsCard: FC<RewardsHighlightsCardProps> = ({ reward, onClick }) => {
	const { t } = useTranslation('rewards');
	const company = useCurrentCompany();
	return (
		<Box
			as="button"
			w="full"
			onClick={onClick}
			cursor="pointer"
			_hover={{ bg: 'secondary.bgAlpha' }}
			borderRadius="lg"
			p={3}
			transition="background 0.2s"
			textAlign="left"
		>
			<HStack spacing={3} align="center">
				<Image
					src={reward.distributionMethod === DistributionMethod.Collectible ? stripesGreen3 : reward.imageUrl}
					alt={reward.imageAltText}
					w="76px"
					h="46px"
					borderRadius="md"
					objectFit="contain"
					bg="white"
					border="1px solid"
					borderColor="border.default"
					boxShadow="sm"
					flexShrink={0}
				/>
				<Box flex={1} minW={0}>
					<Text fontSize="16px" fontWeight="500" lineHeight="24px" letterSpacing="-0.208px" noOfLines={1} color="text.primary">
						{reward.name}
					</Text>
					<Text fontSize="14px" fontWeight="425" lineHeight="20px" letterSpacing="-0.182px" color="text.softest">
						{reward.minAmountInPoints === reward.maxAmountInPoints
							? t('reward_details.priceSingle', {
									amount: reward.minAmountInPoints,
									budget: company.budget,
									formatParams: {
										amount: company.budget.format,
									},
								})
							: t('reward_details.priceRange', {
									min: reward.minAmountInPoints,
									max: reward.maxAmountInPoints,
									budget: company.budget,
									formatParams: {
										min: company.budget.format,
										max: company.budget.format,
									},
								})}
					</Text>
				</Box>
			</HStack>
		</Box>
	);
};
